<template>
  <vl-properties-list v-vl-spacer:bottom.medium>
    <vl-properties-label>{{ $t('productspecification.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('productspecification.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('productspecification.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('productspecification.detail.dataConnection') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.dataConnection ? props.detail.dataConnection?.code : `/` }}</vl-properties-data>
    <vl-properties-label>{{ $t('productspecification.detail.schema') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.schema }}</vl-properties-data>
    <vl-properties-label>{{ $t('productspecification.detail.baseMetadataUuid') }}</vl-properties-label>
    <vl-properties-data
      ><a :href="getMetadataUrl(props.detail.baseMetadataUuid)" class="vl-link" target="_blank">
        {{ props.detail.baseMetadataUuid }}</a
      ></vl-properties-data
    >
    <vl-properties-label>{{ $t('productspecification.detail.isMetadataContinuous') }}</vl-properties-label>
    <vl-properties-data>{{
      props.detail.isMetadataContinuous ? $t('general.yes') : $t('general.no')
    }}</vl-properties-data>
    <vl-properties-label>{{ $t('productspecification.detail.skipMapping') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.skipMapping ? $t('general.yes') : $t('general.no') }}</vl-properties-data>
    <vl-properties-label>{{ $t('productspecification.detail.skipMetadataPublication') }}</vl-properties-label>
    <vl-properties-data>{{
      props.detail.skipMetadataPublication ? $t('general.yes') : $t('general.no')
    }}</vl-properties-data>
    <!-- <vl-properties-label>{{ $t('productspecification.detail.featureCatalog') }}</vl-properties-label>
    <vl-properties-data
      ><a :href="getFeatureCatalogUrl()" class="vl-link" target="_blank">
        {{ $t('productspecification.detail.viewXml') }}</a
      ></vl-properties-data
    > -->
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { ProductSpecificationDetailDto } from '@/api/backoffice/clients';
import { config } from './../../../../../../common/config/config';

const props = defineProps<{
  detail: ProductSpecificationDetailDto;
}>();

const getMetadataUrl = (uuid: string): string => {
  return `${config.integrations.metadataUrl}/${uuid}`;
};

const getFeatureCatalogUrl = (): string => {
  // TODO
  return ``;
};
</script>
